import React from 'react';

import { ReturnToLabel, ShipFromLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

const ShipFrom = () => {
  const { isReturn, shipFrom } = useFulfillmentDisplayContext();

  const label = isReturn ? ReturnToLabel : ShipFromLabel;

  return <ReadonlyField label={label}>{shipFrom}</ReadonlyField>;
};

export default ShipFrom;
